export const KANJI = [
    ["中央", ["chuo"], ["central"]],
    ["中", ["naka"], ["central", "inside"]],
    ["北", ["hoko", "kita"], ["north"]],
    ["南", ["nan", "minami"], ["south"]],
    ["東", ["to", "higashi"], ["east"]],
    ["西", ["sai", "zai", "nishi"], ["west"]],
    ["上", ["kami", "ue"], ["upper"]],
    ["下", ["shimo", "shita"], ["lower", "under"]],
    ["右", ["u"], ["right"]],
    ["左", ["sa"], ["left"]],
    ["横", ["yoko"], ["side"]],

    ["本", ["hon", "moto"], ["origin"]],
    ["新", ["shin"], ["new"]],
    ["古", ["furu", "ko", "go"], ["old"]],
    ["長", ["naga"], ["long"]],
    ["前", ["mae"], ["front"]],
    ["内", ["uchi"], ["inside"]],
    ["外", ["soto", "gae"], ["outside"]],
    ["高", ["taka", "ko"], ["tall"]],
    ["大", ["o"], ["big"]],
    ["小", ["ko", "o"], ["small"]],
    ["広", ["hiro"], ["wide"]],

    ["白", ["shiro"], ["white"]],
    ["黒", ["kuro"], ["black"]],
    ["赤", ["aka"], ["red"]],
    ["青", ["ao"], ["blue"]],
    ["黄", ["ki"], ["yellow"]],
    ["緑", ["midori"], ["green"]],
    ["紫", ["murasaki"], ["purple"]],
    ["灰", ["hai"], ["gray"]],
    ["茶", ["cha"], ["brown", "tea"]],

    ["県", ["-ken"], ["prefecture"]],
    ["府", ["fu"], ["prefecture"]],
    ["郡", ["-gun"], ["district"]],
    ["市", ["-shi"], ["city"]],
    ["区", ["-ku"], ["ward"]],
    ["町", ["-machi", "-chō"], ["town"]],
    ["村", ["-mura", "-son"], ["village"]],
    ["通", ["-dori", "-michi", "-do"], ["street"]],
    ["条", ["-jō"], ["street"]],
    ["港", ["minato", "kō"], ["harbor"]],
    ["津", ["tsu"], ["harbor"]],
    ["宿", ["shuku", "-juku"], ["station town"]],
    ["駅", ["eki"], ["station"]],
    ["橋", ["-hashi", "-bashi"], ["bridge"]],
    ["屋", ["-ya"], ["shop"]],
    ["京", ["kyō"], ["capital"]],
    ["都", ["to"], ["capital, metropolis"]],
    ["道", ["dō", "michi"], ["road"]],
    ["丁目", ["-chōme"], ["block"]],

    ["浜", ["hama"], ["beach"]],
    ["半島", ["hanto"], ["peninsula"]],
    ["石", ["ishi"], ["rock"]],
    ["岩", ["iwa"], ["rock"]],
    ["泉", ["izumi"], ["spring"]],
    ["海峡", ["kaikyo"], ["strait"]],
    ["川", ["kawa", "-gawa"], ["river"]],
    ["河", ["kawa", "-gawa"], ["river (big)"]],
    ["湖", ["ko"], ["lake"]],
    ["灘", ["nada"], ["sea"]],
    ["岡", ["oka"], ["hill"]],
    ["崎", ["-saki", "-zaki"], ["promontory"]],
    ["岬", ["misaki"], ["cape"]],
    ["山", ["yama", "san", "-zan"], ["mountain"]],
    ["沢", ["sawa", "-zawa"], ["swamp"]],
    ["島", ["shima", "-jima"], ["island"]],
    ["谷", ["tani", "-dani", "-ya"], ["valley"]],
    ["湾", ["wan"], ["bay"]],
    ["江", ["e"], ["bay"]],
    ["浦", ["ura"], ["bay"]],
    ["森", ["mori"], ["forest"]],
    ["木", ["ki", "-gi"], ["tree"]],
    ["松", ["matsu"], ["pine"]],
    ["杉", ["sugi"], ["japanese cedar"]],
    ["田", ["ta", "-da"], ["rice paddy"]],
    ["原", ["hara"], ["meadow"]],
    ["野", ["no"], ["field"]],
    ["台", ["tai", "dai"], ["plateau"]],
    ["海", ["umi", "-kai"], ["sea"]],
    ["池", ["ike"], ["pond"]],
    ["平", ["hira", "-taira"], ["plain"]],
    ["尾", ["o"], ["ridge"]],
    ["江", ["e", "ko"], ["inlet"]],
    ["井", ["i"], ["well"]],
    ["潟", ["kata"], ["lagoon"]],
    ["阪", ["saka", "han"], ["slope"]],

    ["福", ["fuku"], ["fortune"]],
    ["仙", ["sen"], ["immortal"]],
    ["富", ["fu", "tomi"], ["wealth"]],
    ["宮", ["miya"], ["shrine"]],
    ["井", ["i"], ["well"]],
    ["吉", ["kichi", "yoshi"], ["lucky"]],
    ["日", ["hi", "nichi"], ["day, sun"]],
    ["徳", ["toku"], ["virtue"]],
    ["和", ["wa"], ["harmony"]],
    ["立", ["tachi", "ritsu"], ["stand"]],
    ["部", ["bu", "be"], ["section"]],
    ["場", ["ba"], ["place"]],
];



export const PLACES: [string, string][] = [
  // Cities/Prefectures
  ["東京", "Tōkyō"],
  ["大阪", "Ōsaka"],
  ["京都", "Kyōto"],
  ["北海道", "Hokkaidō"],
  ["新潟", "Niigata"],
  ["長野", "Nagano"],
  ["富山", "Toyama"],
  ["福岡", "Fukuoka"],
  ["仙台", "Sendai"],
  ["横浜", "Yokohama"],
  
  // Geographic Features (Part 1)
  ["富士山", "Fujisan"],
  ["白山", "Hakusan"],
  ["青森", "Aomori"],
  ["黒部", "Kurobe"],
  ["大島", "Ōshima"],
  ["小島", "Kojima"],
  ["中島", "Nakashima"],
  ["新島", "Niijima"],
  ["白浜", "Shirahama"],
  ["黒崎", "Kurosaki"],
  
  // Districts/Areas (Part 1)
  ["中央", "Chūō"],
  ["新宿", "Shinjuku"],
  ["上野", "Ueno"],
  ["下町", "Shitamachi"],
  ["本町", "Honmachi"],
  ["新町", "Shinmachi"],
  ["古町", "Furumachi"],
  ["大手町", "Ōtemachi"],
  ["高田", "Takada"],
  ["前橋", "Maebashi"],
  
  // Numbered Districts
  ["一丁目", "Ichi-chōme"],
  ["二丁目", "Ni-chōme"],
  ["三丁目", "San-chōme"],
  ["四丁目", "Yon-chōme"],
  ["五丁目", "Go-chōme"],
  
  // Transportation
  ["新橋", "Shinbashi"],
  ["大橋", "Ōhashi"],
  ["高橋", "Takahashi"],
  ["長橋", "Nagahashi"],
  ["白橋", "Shirahashi"],
  
  // Administrative Divisions
  ["中央区", "Chūō-ku"],
  ["北区", "Kita-ku"],
  ["南区", "Minami-ku"],
  ["東区", "Higashi-ku"],
  ["西区", "Nishi-ku"],
  ["港区", "Minato-ku"],
  
  // Rivers/Waters (Part 1)
  ["大川", "Ōkawa"],
  ["小川", "Ogawa"],
  ["長川", "Nagakawa"],
  ["白川", "Shirakawa"],
  ["黒川", "Kurokawa"],
  
  // Cities/Towns (Part 2)
  ["松本", "Matsumoto"],
  ["高松", "Takamatsu"],
  ["大津", "Ōtsu"],
  ["小田原", "Odawara"],
  ["吉田", "Yoshida"],
  ["田中", "Tanaka"],
  ["山田", "Yamada"],
  ["井上", "Inoue"],
  ["石川", "Ishikawa"],
  ["岡山", "Okayama"],
  ["小浜", "Obama"],
  
  // Geographic Features (Part 2)
  ["大山", "Daisan"],
  ["小山", "Oyama"],
  ["高山", "Takayama"],
  ["青山", "Aoyama"],
  ["白石", "Shiraishi"],
  ["黒石", "Kuroishi"],
  ["赤石", "Akaishi"],
  ["長岡", "Nagaoka"],
  ["福山", "Fukuyama"],
  ["松山", "Matsuyama"],
  
  // Bays/Waters
  ["大湾", "Ōwan"],
  ["小湾", "Kowan"],
  ["内海", "Uchiumi"],
  ["外海", "Sotoumi"],
  ["東海", "Tōkai"],
  ["西海", "Saikai"],
  ["南海", "Nankai"],
  ["北海", "Hokkai"],
  
  // Districts/Areas (Part 2)
  ["内田", "Uchida"],
  ["外田", "Sotoda"],
  ["上田", "Ueda"],
  ["下田", "Shimoda"],
  ["右京", "Ukyō"],
  ["左京", "Sakyō"],
  ["中野", "Nakano"],
  ["高野", "Takano"],
  ["大野", "Ōno"],
  ["小野", "Ono"],
  
  // Valleys/Mountains
  ["長谷", "Nagatani"],
  ["大谷", "Ōtani"],
  ["小谷", "Kotani"],
  ["青谷", "Aotani"],
  ["白谷", "Shiratani"],
  ["黒谷", "Kurotani"],
  
  // Islands (Part 2 - note: some duplicates from part 1)
  ["青島", "Aoshima"],
  ["白島", "Shirashima"],
  ["長島", "Nagashima"],
  ["高島", "Takashima"],
  
  // Ports/Harbors
  ["大港", "Ōkō"],
  ["小港", "Kokō"],
  ["新港", "Shinkō"],
  ["東港", "Tōkō"],
  ["西港", "Saikō"],

  // Stations
  ["上野駅", "Ueno-eki"],
  ["下北沢駅", "Shimokitazawa-eki"],
  ["中野駅", "Nakano-eki"],
  ["高田駅", "Takada-eki"],
  ["大手町駅", "Ōtemachi-eki"],
  ["小田原駅", "Odawara-eki"],
  ["松本駅", "Matsumoto-eki"],
  ["長野駅", "Nagano-eki"],
  ["富山駅", "Toyama-eki"],
  ["福岡駅", "Fukuoka-eki"],
  ["青森駅", "Aomori-eki"],
  ["仙台駅", "Sendai-eki"],
  ["岡山駅", "Okayama-eki"],
  ["高松駅", "Takamatsu-eki"],
  ["大津駅", "Ōtsu-eki"],
  ["石川駅", "Ishikawa-eki"],
  ["白石駅", "Shiraishi-eki"],
  ["黒崎駅", "Kurosaki-eki"],
  ["赤羽駅", "Akabane-eki"],
  ["田町駅", "Tamachi-eki"],
  ["森ノ宮駅", "Morinomiya-eki"],
  ["大宮駅", "Ōmiya-eki"],
  ["小宮駅", "Komiya-eki"],
  ["西宮駅", "Nishinomiya-eki"],
  ["東宮駅", "Tōmiya-eki"],
  ["新宮駅", "Shingū-eki"],
  ["宮前駅", "Miyamae-eki"],
  ["宮本駅", "Miyamoto-eki"],
  ["宮田駅", "Miyata-eki"],
  ["宮崎駅", "Miyazaki-eki"],
  ["川崎駅", "Kawasaki-eki"],
  ["山手駅", "Yamanote-eki"],
  ["島田駅", "Shimada-eki"],
  ["湾岸駅", "Wangan-eki"],
  ["江戸川駅", "Edogawa-eki"],
  ["木場駅", "Kiba-eki"],
  ["原宿駅", "Harajuku-eki"],
  ["台場駅", "Daiba-eki"],
  ["池袋駅", "Ikebukuro-eki"],
  ["尾山台駅", "Oyamadai-eki"],
  
  // Neighborhoods/Districts
  ["上野", "Ueno"],
  ["下北沢", "Shimokitazawa"],
  ["中野", "Nakano"],
  ["高田", "Takada"],
  ["大手町", "Ōtemachi"],
  ["小田原", "Odawara"],
  ["田町", "Tamachi"],
  ["本郷", "Hongō"],
  ["新宿", "Shinjuku"],
  ["古川", "Furukawa"],
  ["長谷", "Hase"],
  ["前原", "Maehara"],
  ["内幸町", "Uchisaiwai-chō"],
  ["外苑前", "Gaien-mae"],
  ["高野", "Takano"],
  ["大野", "Ōno"],
  ["小野", "Ono"],
  ["広尾", "Hiroo"],
  ["白金", "Shirokane"],
  ["黒門", "Kuromon"],
  ["赤坂", "Akasaka"],
  ["青山", "Aoyama"],
  ["緑が丘", "Midorigaoka"],
  ["紫野", "Murasaki-no"],
  ["茶屋町", "Chaya-machi"],
  ["灰塚", "Haizuka"],
  ["森ノ宮", "Morinomiya"],
  ["谷町", "Tanimachi"],
  ["石町", "Ishimachi"],
  ["岩本町", "Iwamoto-chō"],
  ["泉町", "Izumi-chō"],
  ["川口", "Kawaguchi"],
  ["河原町", "Kawaramachi"],
  ["湖南", "Konan"],
  ["灘区", "Nada-ku"],
  ["崎町", "Sakimachi"],
  ["岬町", "Misakimachi"],
  ["沢井", "Sawai"],
  ["谷原", "Tanihara"],
  ["湾岸", "Wangan"],
  ["江戸川", "Edogawa"],
  ["浦安", "Urayasu"],
  ["木場", "Kiba"],
  ["杉並", "Suginami"],
  ["原宿", "Harajuku"],
  ["野田", "Noda"],
  ["台場", "Daiba"],
  ["池袋", "Ikebukuro"],
  ["平井", "Hirai"],
  ["尾山台", "Oyamadai"],
  ["井の頭", "Inokashira"],
  ["潟上", "Katagami"],
  
  // Full Chōme Names
  ["谷町六丁目", "Tanimachi-roku-chōme"],
  ["本町三丁目", "Honmachi-san-chōme"],
  ["新町二丁目", "Shinmachi-ni-chōme"],
  ["古町五丁目", "Furumachi-go-chōme"],
  ["大手町一丁目", "Ōtemachi-ichi-chōme"],
  ["上野三丁目", "Ueno-san-chōme"],
  ["下町七丁目", "Shitamachi-nana-chōme"],
  ["中野四丁目", "Nakano-yon-chōme"],
  ["高田八丁目", "Takada-hachi-chōme"],
  ["田町二丁目", "Tamachi-ni-chōme"],
  ["前原六丁目", "Maehara-roku-chōme"],
  ["長野一丁目", "Nagano-ichi-chōme"],
  ["小田原五丁目", "Odawara-go-chōme"],

  // Cities (市)
  ["大田市", "Ōta-shi"],
  ["小田市", "Oda-shi"],
  ["上田市", "Ueda-shi"],
  ["下田市", "Shimoda-shi"],
  ["田原市", "Tahara-shi"],
  ["原市", "Hara-shi"],
  ["野田市", "Noda-shi"],
  ["台場市", "Daiba-shi"],
  ["海津市", "Kaizu-shi"],
  ["池田市", "Ikeda-shi"],
  ["平田市", "Hirata-shi"],
  ["尾道市", "Onomichi-shi"],
  ["井原市", "Ibara-shi"],
  ["潟上市", "Katagami-shi"],
  
  // Towns (町)
  ["大島町", "Ōshima-machi"],
  ["小島町", "Kojima-machi"],
  ["中島町", "Nakashima-machi"],
  ["新島町", "Niijima-machi"],
  ["長島町", "Nagashima-machi"],
  ["高島町", "Takashima-machi"],
  ["青島町", "Aoshima-machi"],
  ["白浜町", "Shirahama-machi"],
  ["黒崎町", "Kurosaki-machi"],
  ["赤井町", "Akai-machi"],
  ["緑町", "Midori-machi"],
  ["紫波町", "Shiwa-machi"],
  ["茶屋町", "Chaya-machi"],
  ["灰塚町", "Haizuka-machi"],
  ["石川町", "Ishikawa-machi"],
  ["岩井町", "Iwai-machi"],
  ["泉町", "Izumi-machi"],
  ["川口町", "Kawaguchi-machi"],
  ["河原町", "Kawara-machi"],
  ["湖南町", "Konan-machi"],
  ["岡田町", "Okada-machi"],
  ["崎浜町", "Sakihama-machi"],
  ["岬町", "Misaki-machi"],
  ["山田町", "Yamada-machi"],
  ["沢井町", "Sawai-machi"],
  ["島田町", "Shimada-machi"],
  ["谷原町", "Tanihara-machi"],
  ["湾岸町", "Wangan-machi"],
  ["江田町", "Eda-machi"],
  ["浦町", "Ura-machi"],
  ["森町", "Mori-machi"],
  ["木田町", "Kida-machi"],
  ["松原町", "Matsubara-machi"],
  ["杉原町", "Sugihara-machi"],
  ["田原町", "Tahara-machi"],
  ["原田町", "Harada-machi"],
  ["野原町", "Nohara-machi"],
  ["台原町", "Daihara-machi"],
  
  // Villages (村)
  ["大島村", "Ōshima-mura"],
  ["小島村", "Kojima-mura"],
  ["中島村", "Nakashima-mura"],
  ["長島村", "Nagashima-mura"],
  ["白川村", "Shirakawa-mura"],
  ["黒川村", "Kurokawa-mura"],
  ["青海村", "Ōmi-mura"],
  ["赤井村", "Akai-mura"],
  ["緑村", "Midori-mura"],
  ["石井村", "Ishii-mura"],
  ["岩井村", "Iwai-mura"],
  ["泉村", "Izumi-mura"],
  ["川上村", "Kawakami-mura"],
  ["河内村", "Kawachi-mura"],
  ["湖上村", "Kojō-mura"],
  ["岡村", "Oka-mura"],
  ["崎村", "Saki-mura"],
  ["岬村", "Misaki-mura"],
  ["山上村", "Yamagami-mura"],
  ["沢村", "Sawa-mura"],
  ["島村", "Shima-mura"],
  ["谷村", "Tani-mura"],
  ["江村", "E-mura"],
  ["浦村", "Ura-mura"],
  ["森村", "Mori-mura"],
  ["木村", "Ki-mura"],
  ["松村", "Matsu-mura"],
  ["杉村", "Sugi-mura"],
  ["田村", "Ta-mura"],
  ["原村", "Hara-mura"],
  ["野村", "No-mura"],
  ["台村", "Dai-mura"],
  ["海村", "Umi-mura"],
  ["池村", "Ike-mura"],
  ["平村", "Hira-mura"],
  ["尾村", "O-mura"],
  ["井村", "I-mura"],
  ["潟村", "Kata-mura"],
  
  // Historic/Traditional Names
  ["上野原町", "Uenohara-machi"],
  ["下野原村", "Shimonohara-mura"],
  ["内海町", "Uchiumi-machi"],
  ["外海村", "Sotoumi-mura"],
  ["前田町", "Maeda-machi"],
  ["本田村", "Honda-mura"],
  ["新田町", "Nitta-machi"],
  ["古田村", "Furuta-mura"],



  ["本港新町", "Honkoshinmachi"],

  // Towns and Villages
  ["上山町", "Kamiyama-machi"],
  ["下野町", "Shimono-machi"],
  ["中島村", "Nakashima-mura"],
  ["内海町", "Uchiumi-machi"],
  ["外山村", "Toyama-mura"],
  ["高野町", "Takano-machi"],
  ["小野町", "Ono-machi"],
  ["広野町", "Hirono-machi"],
  ["新田町", "Nitta-machi"],
  ["古川町", "Furukawa-machi"],
  
  // Geographic Features (Part 1)
  ["白根山", "Shirane-san"],
  ["黒岳", "Kuro-dake"],
  ["緑山", "Midori-yama"],
  ["大沢", "O-sawa"],
  ["小沢", "Ko-sawa"],
  ["長沢", "Naga-sawa"],
  ["上池", "Kami-ike"],
  ["下池", "Shimo-ike"],
  
  // Small Stations (Part 1)
  ["白石駅", "Shiraishi-eki"],
  ["黒崎駅", "Kurosaki-eki"],
  ["大野駅", "Ono-eki"],
  ["小野駅", "Ono-eki"],
  ["上田駅", "Ueda-eki"],
  ["下田駅", "Shimoda-eki"],
  ["内田駅", "Uchida-eki"],
  ["前原駅", "Maehara-eki"],
  
  // Neighborhoods
  ["本町", "Hon-machi"],
  ["新町", "Shin-machi"],
  ["古町", "Furu-machi"],
  ["上町", "Kami-machi"],
  ["下町", "Shimo-machi"],
  ["中町", "Naka-machi"],
  ["左京", "Sakyo"],
  ["右京", "Ukyo"],
  ["木島村", "Kijima-mura"],
  ["松島町", "Matsushima-machi"],
  ["杉原村", "Sugihara-mura"],
  ["田中町", "Tanaka-machi"],
  ["原田村", "Harada-mura"],
  ["野原町", "Nohara-machi"],
  ["台原村", "Daihara-mura"],
  ["海田町", "Kaita-machi"],
  ["池上村", "Ikegami-mura"],
  ["平野町", "Hirano-machi"],
  
  // Geographic Features (Part 2)
  ["尾根山", "One-yama"],
  ["井戸沢", "Ido-sawa"],
  ["潟湖", "Kata-ko"],
  ["阪本", "Sakamoto"],
  ["福田川", "Fukuda-gawa"],
  ["仙石原", "Sengokuhara"],
  ["富岡", "Tomioka"],
  ["宮原", "Miyahara"],
  ["吉田山", "Yoshida-yama"],
  ["日野原", "Hinohara"],
  
  // Small Stations (Part 2)
  ["木場駅", "Kiba-eki"],
  ["松原駅", "Matsubara-eki"],
  ["杉田駅", "Sugita-eki"],
  ["田野駅", "Tano-eki"],
  ["原町駅", "Hara-machi-eki"],
  ["台場駅", "Daiba-eki"],
  ["海老名駅", "Ebina-eki"],
  ["尾道駅", "Onomichi-eki"],
  ["井原駅", "Ihara-eki"],
  
  // Local Areas
  ["徳田", "Tokuda"],
  ["和田", "Wada"],
  ["立石", "Tateishi"],
  ["一ノ宮", "Ichinomiya"],
  ["二子", "Futako"],
  ["三田", "Mita"],
  ["四谷", "Yotsuya"],
  ["五反田", "Gotanda"],
  ["六本木", "Roppongi"],
  ["七里", "Nanasato"],
  
  // Small Towns/Villages
  ["石田町", "Ishida-machi"],
  ["岩田村", "Iwata-mura"],
  ["泉原町", "Izumihara-machi"],
  ["川田村", "Kawata-mura"],
  ["河内町", "Kawachi-machi"],
  ["湖南村", "Konan-mura"],
  ["灘町", "Nada-machi"],
  ["岡本村", "Okamoto-mura"],
  ["崎山町", "Sakiyama-machi"],
  ["岬村", "Misaki-mura"],
  
  // Geographic Features (Part 3)
  ["沢田", "Sawada"],
  ["島田", "Shimada"],
  ["谷田", "Tanida"],
  ["湾内", "Wannai"],
  ["江田", "Eda"],
  ["浦田", "Urata"],
  ["森田", "Morita"],
  ["松田", "Matsuda"],
  ["杉田", "Sugita"],
  ["竹田", "Takeda"],
  
  // Small Stations (Part 3)
  ["石川駅", "Ishikawa-eki"],
  ["岩井駅", "Iwai-eki"],
  ["泉駅", "Izumi-eki"],
  ["川西駅", "Kawanishi-eki"],
  ["湖東駅", "Koto-eki"],
  ["岡田駅", "Okada-eki"],
  ["崎浜駅", "Sakihama-eki"],
  ["沢井駅", "Sawai-eki"],
  ["島本駅", "Shimamoto-eki"],
  ["谷山駅", "Taniyama-eki"],
  
  // Local Districts
  ["内野", "Uchino"],
  ["外野", "Sotono"],
  ["前田", "Maeda"],
  ["長田", "Nagata"],
  ["高田", "Takada"],
  ["大田", "Ota"],
  ["小田", "Oda"],
  ["広田", "Hirota"],
  ["白田", "Shirata"],
  ["黒田", "Kuroda"],
  
  // Tourist/Special Places
  ["上高地", "Kamikochi"],
  
  // Cities
  ["下呂市", "Gero-shi"],
  ["中津川市", "Nakatsugawa-shi"],
  ["上越市", "Joetsu-shi"],
  ["下関市", "Shimonoseki-shi"],
  ["東海市", "Tokai-shi"],
  ["西海市", "Saikai-shi"],
  ["南海町", "Nankai-machi"],
  ["北海町", "Hokkai-machi"],
  
  // Long Station Names
  ["上野原駅", "Uenohara-eki"],
  ["下野原駅", "Shimonohara-eki"],
  ["中野坂上駅", "Nakano-sakaue-eki"],
  ["前橋大島駅", "Maebashi-oshima-eki"],
  ["新前橋駅", "Shin-maebashi-eki"],
  ["古川橋駅", "Furukawabashi-eki"],
  ["大島口駅", "Oshima-guchi-eki"],
  
  // Long Geographic Names
  ["上野原市", "Uenohara-shi"],
  ["下野市", "Shimono-shi"],
  ["中野市", "Nakano-shi"],
  ["前橋市", "Maebashi-shi"],
  ["本庄市", "Honjo-shi"],
  ["新座市", "Niiza-shi"],
  ["古河市", "Koga-shi"],
  
  // Full Address Style
  ["東京都中央区日本橋", "Tokyo-to Chuo-ku Nihonbashi"],
  ["大阪府大阪市中央区", "Osaka-fu Osaka-shi Chuo-ku"],

  // Compound Station Names
  ["上野公園駅", "Ueno-koen-eki"],
  ["下野宮駅", "Shimono-miya-eki"],
  ["中野富士見町駅", "Nakano-fujimichou-eki"],
  ["前原高校前駅", "Maehara-koukoumai-eki"],
  ["本郷三丁目駅", "Hongo-sanchome-eki"],
  ["新宿三丁目駅", "Shinjuku-sanchome-eki"],
  ["古市橋駅", "Furuichi-bashi-eki"],
  ["長野原草津口駅", "Naganohara-kusatsuguchi-eki"],
  ["高田馬場駅", "Takada-no-baba-eki"],
  ["大手町前駅", "Otemachi-mae-eki"],
  ["小田急永山駅", "Odakyu-nagayama-eki"],
  ["広島新白島駅", "Hiroshima-shinshirashima-eki"],
  ["白石蔵王駅", "Shiraishi-zao-eki"],
  ["黒崎播磨駅", "Kurosaki-harima-eki"],
  ["赤羽岩淵駅", "Akabane-iwabuchi-eki"],
  ["青海駅", "Aoumi-eki"],
  ["緑地公園駅", "Ryokuchi-koen-eki"],

  // Directional Compound Names
  ["東松山駅", "Higashi-matsuyama-eki"],
  ["西高島平駅", "Nishi-takashimadaira-eki"],
  ["南新宿駅", "Minami-shinjuku-eki"],
  ["北新横浜駅", "Kita-shin-yokohama-eki"],
  ["上大岡駅", "Kami-oooka-eki"],
  ["下高井戸駅", "Shimo-takaido-eki"],
  ["新田駅前駅", "Nitta-ekimae-eki"],
  ["古川橋駅", "Furukawa-bashi-eki"],
  ["本町田駅", "Honmachi-da-eki"],
  ["中野新橋駅", "Nakano-shinbashi-eki"],
  ["上野毛駅", "Ueno-ge-eki"],
  ["前田駅前駅", "Maeda-ekimae-eki"],
  ["内野西駅", "Uchino-nishi-eki"],
  ["外苑前駅", "Gaien-mae-eki"],
  ["高野台駅", "Takano-dai-eki"],
  ["大野城駅", "Ono-jo-eki"],
  ["小野田駅", "Onoda-eki"],
  ["広野駅前駅", "Hirono-ekimae-eki"],
  ["白新田駅", "Shira-nitta-eki"],
  ["黒磯駅", "Kuro-iso-eki"],
  ["赤土小学校前駅", "Akatsuchi-shogakkomae-eki"],
  ["青梅街道駅", "Ome-kaido-eki"],
  ["緑町駅前駅", "Midorimachi-ekimae-eki"],

  // Geographic Compound Names
  ["石川台駅", "Ishikawa-dai-eki"],
  ["岩本町駅", "Iwamoto-cho-eki"],
  ["泉中央駅", "Izumi-chuo-eki"],
  ["河原町駅", "Kawara-machi-eki"],
  ["湖西駅", "Kosai-eki"],
  ["東海市", "Tokai-shi"],
  ["西海市", "Saikai-shi"],
  ["南海市", "Nankai-shi"],
  ["北海市", "Hokkai-shi"],
  ["上野原市", "Uenohara-shi"],
  ["下野市", "Shimono-shi"],
  ["中津川市", "Nakatsugawa-shi"],
  ["前橋市", "Maebashi-shi"],
  ["古河市", "Koga-shi"],

  // Compound Geographic Features
  ["中禅寺湖", "Chuzenji-ko"],
  ["高野山", "Koya-san"],
  ["大台ヶ原", "Odaigahara"],
  ["広島湾", "Hiroshima-wan"],

  // Compound Districts
  ["白金台", "Shirokane-dai"],
  ["黒門市場", "Kuromon-ichiba"],
  ["赤坂見附", "Akasaka-mitsuke"],
  ["青山一丁目", "Aoyama-itchome"],
  ["紫野", "Murasaki-no"],
  ["茶屋町", "Chaya-machi"],

  // Compound Bridges/Infrastructure
  ["新大橋", "Shin-ohashi"],
  ["古川橋", "Furukawa-bashi"],
  ["本町橋", "Honmachi-bashi"],
  ["中央大橋", "Chuo-ohashi"],
  ["前田大橋", "Maeda-ohashi"],

  // Temple/Shrine Compound Names
  ["中山寺", "Nakayama-dera"],
  ["高野山寺", "Koyasan-ji"]
];